<template>
    <div>
      <div v-if="tabIndex !== 5" class="buton_salvar">
        <!-- 2026-05-29: salvar e publicar separados. SALVAR persiste edições (mantém rascunho);
             PUBLICAR libera pro mobile (valida completude); DESPUBLICAR volta pra rascunho. -->
        <button
          class="buttonsave"
          @click="validaDados"
        >
        <i class="fas fa-save"></i> SALVAR
        </button>
        <button
          v-if="statusTemplate !== 'ATIVO'"
          class="buttonpublish"
          @click="publicarTemplate"
        >
        <i class="fas fa-check-circle"></i> PUBLICAR
        </button>
        <button
          v-else
          class="buttonunpublish"
          @click="despublicarTemplate"
        >
        <i class="fas fa-eye-slash"></i> DESPUBLICAR
        </button>
        <!-- ZOP-65: duplicar sai daqui e nao da listagem porque a coluna de acoes usa o
             TableColumn compartilhado; mexer nele afetaria todas as telas do sistema. -->
        <button
          class="buttonduplicate"
          @click="abrirDuplicar"
        >
        <i class="fas fa-copy"></i> DUPLICAR
        </button>
      </div>

      <b-modal ref="modal-duplicar" size="md" centered :hide-footer="true"
               :no-close-on-backdrop="true" body-class="rounded-bottom-1rem" content-class="rounded-1rem">
        <template #modal-title><div class="header-title">DUPLICAR TEMPLATE</div></template>
        <div class="p-2">
          <p class="text-muted" style="font-size: 13px;">
            A copia leva orientacoes, cabecalho, etapas, perguntas e assinaturas, e nasce como
            <b>RASCUNHO</b> independente. Os formularios ja preenchidos nao sao copiados.
          </p>
          <b-form-group label="Codigo do novo template *">
            <b-form-input v-model="duplicarCodigo" placeholder="Digite o codigo" />
          </b-form-group>
          <b-form-group label="Codigo PES">
            <b-form-input v-model="duplicarPES" placeholder="Codigo PES" />
          </b-form-group>
          <div class="d-flex justify-content-end" style="gap: 8px;">
            <button class="buttonunpublish" @click="fecharDuplicar">CANCELAR</button>
            <button class="buttonpublish" :disabled="!duplicarCodigo" @click="confirmarDuplicar">DUPLICAR</button>
          </div>
        </div>
      </b-modal>

        <b-tabs v-model="tabIndex">
            <b-tab :title="'Autorizações'">
              <template slot="title" >
              <span class="d-md-down-none pl-1 text-third">Orientações</span>
              </template>
                <HeadDetailsGama :titleHead="'Detalhes do Template'"  style="font-family: 'Segoe UI'" :buttontemplate="true" v-on:voltarPersonalizado="voltar()" :btnBack="true">
                <template #button-edit>
                  <div class="d-flex">
                    <button
                      class="font font-bold"
                      :disabled="isDisabledOrientacao"
                      :class="{ excDisable: isDisabledOrientacao, exc: !isDisabledOrientacao }"
                      @click="popUpExclusaoItensAguardandoOrientacaoEnvio">
                      <i class="fas fa-minus"></i> EXCLUIR NOVAS ORIENTAÇÕES
                    </button>
                    <div class="font font-bold  add" style="color: #008144;" @click="popUpOrientacao">
                      <i class="fas fa-plus"></i> ADICIONAR ORIENTAÇÃO
                    </div>
                  </div>
                </template>
                </HeadDetailsGama>
                <guidanceTemplate
                  ref="orientacao"
                  :templateid="templateid"
                  @removerItensparaEdicaoAtivacaoOrientacaoExclusao="removerItensparaEdicaoAtivacaoOrientacaoExclusao"
                  @removerItensparaEdicaoInativacaoOrientacaoExclusao="removerItensparaEdicaoInativacaoOrientacaoExclusao"
                  @addEdicaoAtivacaoOrientacao="addEdicaoAtivacaoOrientacao"
                  @addEdicaoInativacaoOrientacao="addEdicaoInativacaoOrientacao"
                  @removerItensparaEdicaoExclusaoOrientacao="removerItensparaEdicaoExclusaoOrientacao"
                  @liberaButonEdicaoExclusao="liberaButonEdicaoExclusao"
                  @EditaOrientacao="EditaOrientacao"
                  @popUpOrientacao="popUpOrientacao"
                  @popUpOrientacaoEditar="popUpOrientacaoEditar"
                  @removerdeleteOrientacao="removerdeleteOrientacao"
                  :novosItensTableOrientacao="novosItensTableOrientacao"
                  :editarItensTableOrientacao="editarItensTableOrientacao"
                >
                </guidanceTemplate>
             </b-tab>

             <b-tab :title="'Autorizações'">
              <template slot="title" >
              <span class="d-md-down-none pl-1 text-third">Cabeçalho</span>
              </template>
                <HeadDetailsGama :titleHead="'Detalhes do Template'" style="font-family: 'Segoe UI'" :buttontemplate="true" v-on:voltarPersonalizado="voltar()" :btnBack="true">
                <template #button-edit>
                  <div class="d-flex">
                    <button
                      class="font font-bold"
                      :class="{ excDisable: isDisabledCabecalho, exc: !isDisabledCabecalho }"
                      :disabled="isDisabledCabecalho"
                      @click="popUpExclusaoItensAguardandoCabecalhoEnvio">
                      <i class="fas fa-minus"></i> EXCLUIR EDIÇÕES
                    </button>

                    <div class="font font-bold  add" style="color: #008144;" @click="abrirPopUp">
                      <i class="fas fa-plus"></i> ADICIONAR NOVOS ITENS AO CABEÇALHO
                    </div>
                  </div>
                </template>
                </HeadDetailsGama>
                <headerTemplate :templateid="templateid"
                 ref="tableCabecalho"
                  @removerItensparaEdicaoAtivacaoExclusao="removerItensparaEdicaoAtivacaoExclusao"
                  @removerItensparaEdicaoInativacaoExclusao="removerItensparaEdicaoInativacaoExclusao"
                  @addEdicaoInativacao="addEdicaoInativacao"
                  @addEdicaoAtivacao="addEdicaoAtivacao"
                  @removerItensparaEdicaoExclusao="removerItensparaEdicaoExclusao"
                  @liberaButonEdicaoExclusao="liberaButonEdicaoExclusao"
                  @AlterandoNivelPrioridadeCabecalho="AlterandoNivelPrioridadeCabecalho"
                  @popUpCabecalho="popUpCabecalho"
                  @removerExclusao="removerExclusao"
                  :novosItensTableCabecalho="novosItensTableCabecalho"
                 ></headerTemplate>
             </b-tab>

             <b-tab :title="'Autorizações'" v-if="tipoTemplate === 2">
              <template slot="title" >
              <span class="d-md-down-none pl-1 text-third">Pré-requisito</span>
              </template>
                <HeadDetailsGama :titleHead="'Detalhes do Template'"  style="font-family: 'Segoe UI'" :buttontemplate="true" v-on:voltarPersonalizado="voltar()" :btnBack="true">
                <template #button-edit>
                  <div class="d-flex">
                    <!-- <div class="font font-bold  add" style="color: #008144;" @click="abrirPopUpPreRequisito" v-if="semEtapaPrequisito === false">
                      <i class="fas fa-plus"></i> ADICIONAR NOVA PERGUNTA
                    </div> -->
                    <div class="font font-bold  excPreRequisito" style="color: rgb(136, 22, 22);" @click="abrirPopUpExcluirPreRequisito"  v-if="semEtapaPrequisito === false">
                      <i v-b-tooltip.hover :title="'Excluir itens'" class="fas fa-trash"></i>
                    </div>
                  </div>
                </template>
                </HeadDetailsGama>
                <prerequisiteTemplate
                  ref="preRequisito"
                  :templateid="templateid"
                  @NovaPerguntaPreRequisito="NovaPerguntaPreRequisito"
                  @EditaPreRequisitoNovaPergunta="EditaPreRequisitoNovaPergunta"
                  @ExcluirNovaPerguntaPreRequisito="ExcluirNovaPerguntaPreRequisito"
                  @EditaPreRequisitoPergunta="EditaPreRequisitoPergunta"
                  @ExcluirPerguntaPreRequisito="ExcluirPerguntaPreRequisito"
                  @semEtapaPreRequisito="semEtapaPreRequisito"
                  @RemoverExclusaoPerguntaPreRequisito="RemoverExclusaoPerguntaPreRequisito">
                </prerequisiteTemplate>
             </b-tab>
            <b-tab :title="'Autorizações'" v-if="tipoTemplate === 1">
              <template slot="title" >

              <span class="d-md-down-none pl-1 text-third">Equipamento</span>
              </template>
                <HeadDetailsGama :titleHead="'Detalhes do Template'"  style="font-family: 'Segoe UI'" :buttontemplate="true" v-on:voltarPersonalizado="voltarEquipamento()" :btnBack="true">
                <template #button-edit>
                  <div class="d-flex">

                    <div v-if="voltaGrupoTab === false" class="font font-bold  add" style="color: #008144;" @click="abrirPopUpAddNovasEtapasEquipamentos">
                      <i class="fas fa-plus"></i> ADICIONAR NOVA ETAPA
                    </div>
                    <div class="font font-bold  excPreRequisito" style="color: rgb(136, 22, 22);" @click="abrirPopUpExcluirEquipamento">
                      <i v-b-tooltip.hover :title="'Excluir itens'" class="fas fa-trash"></i>
                    </div>
                  </div>
                </template>
                </HeadDetailsGama>
                <equipmentTemplate
                  ref="equipamentoPIT"
                  @voltaGrupo="voltaGrupo"
                  @addNovaEtapa="addNovaEtapa"
                  @editarEtapa="editarEtapa"
                  @editaSubEtapa="editaSubEtapa"
                  @addNovaSubEtapaObjEtapaNova="addNovaSubEtapaObjEtapaNova"
                  @addNovaPerguntaObjEtapaNova="addNovaPerguntaObjEtapaNova"
                  @editaSubEtapaEquipamento="editaSubEtapaEquipamento"
                  @addNovaSubEtapaObjSemNovaEtapa="addNovaSubEtapaObjSemNovaEtapa"
                  @addNovaPerguntaParaSubEtapa="addNovaPerguntaParaSubEtapa"
                  @addNovaPerguntaEtapaSubCriada="addNovaPerguntaEtapaSubCriada"
                  @ExcluirPerguntaPerguntaEquipamentoCriado="ExcluirPerguntaPerguntaEquipamentoCriado"
                  @ExcluirPerguntaEquipamento="ExcluirPerguntaEquipamento"
                  @RemoverEdicaoExcluirPerguntaEquipamento="RemoverEdicaoExcluirPerguntaEquipamento"
                  @ExcluirSubEtapasEtapas="ExcluirSubEtapasEtapas"
                  @removerExclusaoEtapaSubEtapaEquipamento="removerExclusaoEtapaSubEtapaEquipamento"
                  @EditaEquipamentoPergunta="EditaEquipamentoPergunta"
                  @EditaEquipamentoNovaPergunta="EditaEquipamentoNovaPergunta"
                  @editarEmMemoriaNovaPerguntaEtapaSubCriada="editarEmMemoriaNovaPerguntaEtapaSubCriada"
                  @editarEmMemoriaNovaPerguntaParaSubEtapa="editarEmMemoriaNovaPerguntaParaSubEtapa"
                  @editarEmMemoriaNovaPerguntaParaEtapa="editarEmMemoriaNovaPerguntaParaEtapa"
                  @novaEtapaTemplatePergunta="novaEtapaTemplatePergunta"
                  @removerSubEtapaAgEnvioEtapa="removerSubEtapaAgEnvioEtapa"
                  @removerSubEtapaEtapaCriada="removerSubEtapaEtapaCriada"
                  @removerEtapaEquipamentoEstatica="removerEtapaEquipamentoEstatica"
                  :templateid="templateid">
                </equipmentTemplate>
             </b-tab>
             <b-tab :title="'Autorizações'">
              <template slot="title" >
              <span class="d-md-down-none pl-1 text-third">Template</span>
              </template>
                <HeadDetailsGama :titleHead="'Detalhes do Template'"  style="font-family: 'Segoe UI'" :buttontemplate="true" v-on:voltarPersonalizado="voltarTemplate()" :btnBack="true">
                <template #button-edit>
                  <div class="d-flex">
                    <div class="font font-bold  add" style="color: #008144;" @click="abrirPopUpAddNovasEtapasTemplate">
                      <i class="fas fa-plus"></i> ADICIONAR NOVA ETAPA
                    </div>
                    <div class="font font-bold  excPreRequisito" style="color: rgb(136, 22, 22);" @click="abrirPopUpExcluirTemplate">
                      <i v-b-tooltip.hover :title="'Excluir itens'" class="fas fa-trash"></i>
                    </div>
                  </div>
                </template>
                </HeadDetailsGama>

                <templateDetail
                ref="template"
                :templateid="templateid"
                @voltaGrupo="voltaGrupo"
                @addNovaEtapaTemplate="addNovaEtapaTemplate"
                @editarEtapa="editarEtapa"
                @editaSubEtapa="editaSubEtapa"
                @addNovaSubEtapaTemplateObjEtapaNova="addNovaSubEtapaTemplateObjEtapaNova"
                @novaEtapaTemplatePergunta="novaEtapaTemplatePergunta"
                @addNovaSubEtapaObjSemNovaEtapaTemplate="addNovaSubEtapaObjSemNovaEtapaTemplate"
                @addNovaPerguntaParaSubEtapaTemplate="addNovaPerguntaParaSubEtapaTemplate"
                @addNovaPerguntaEtapaSubCriadaTemplate="addNovaPerguntaEtapaSubCriadaTemplate"
                @ExcluirPerguntaTemplateDetalheCriado="ExcluirPerguntaTemplateDetalheCriado"
                @ExcluirPerguntaTemplateDetalheSubEtapa="ExcluirPerguntaTemplateDetalheSubEtapa"
                @ExcluirPerguntaTemplateDetalheEtapa="ExcluirPerguntaTemplateDetalheEtapa"
                @removerSubEtapaEtapaTemplateCriada="removerSubEtapaEtapaTemplateCriada"
                @removerSubEtapaTemplateAgEnvioEtapa="removerSubEtapaTemplateAgEnvioEtapa"
                @ExcluirPerguntaTemplate="ExcluirPerguntaTemplate"
                @RemoverEdicaoExcluirPerguntaTemplate="RemoverEdicaoExcluirPerguntaTemplate"
                @ExcluirSubEtapasEtapasTemplateDetalhe="ExcluirSubEtapasEtapasTemplateDetalhe"
                @removerExclusaoEtapaSubEtapa="removerExclusaoEtapaSubEtapa"
                @EditaTemplatePergunta="EditaTemplatePergunta"
                @editarEmMemoriaNovaPerguntaParaEtapaTemplate="editarEmMemoriaNovaPerguntaParaEtapaTemplate"
                @editarEmMemoriaNovaPerguntaParaSubEtapaTemplate="editarEmMemoriaNovaPerguntaParaSubEtapaTemplate"
                @EditaTemplateNovaPergunta="EditaTemplateNovaPergunta"
                @addNovaPerguntaImagem="addNovaPerguntaImagem"
                @EditarNovaPerguntaImagem="EditarNovaPerguntaImagem"
                @removerImagemNova=removerImagemNova
                @removerEtapaEstatica="removerEtapaEstatica"
                ></templateDetail>
             </b-tab>
             <b-tab :title="'Autorizações'">
              <template slot="title" >
              <span class="d-md-down-none pl-1 text-third">Assinatura</span>
              </template>
                <HeadDetailsGama :titleHead="'Detalhes do Template'"  style="font-family: 'Segoe UI'" :buttontemplate="true" v-on:voltarPersonalizado="voltar()" :btnBack="true">
                <template #button-edit>
                  <div class="d-flex">
                    <button
                      class="font font-bold"
                      :disabled="isDisabledAssinatura"
                      :class="{ excDisable: isDisabledAssinatura, exc: !isDisabledAssinatura }"
                      @click="popUpExclusaoItensAguardandoAssinaturaEnvio">
                      <i class="fas fa-minus"></i> EXCLUIR EDIÇÕES
                    </button>

                    <div class="font font-bold  add" style="color: #008144;" @click="popUpAssinatura">
                      <i class="fas fa-plus"></i> ADICIONAR ASSINATURAS
                    </div>
                  </div>
                </template>
                </HeadDetailsGama>
                <signatureTemplate
                  ref="assinatura"
                  :templateid="templateid"
                  @removerItensparaEdicaoAtivacaoAssinaturaExclusao="removerItensparaEdicaoAtivacaoAssinaturaExclusao"
                  @removerItensparaEdicaoInativacaoAssinaturaExclusao="removerItensparaEdicaoInativacaoAssinaturaExclusao"
                  @addEdicaoAtivacaoAssinatura="addEdicaoAtivacaoAssinatura"
                  @addEdicaoInativacaoAssinatura="addEdicaoInativacaoAssinatura"
                  @removerItensparaEdicaoExclusaoAssinatura="removerItensparaEdicaoExclusaoAssinatura"
                  @liberaButonEdicaoExclusao="liberaButonEdicaoExclusao"
                  @popUpAssinatura="popUpAssinatura"
                  @AlterandoNivelPrioridadeAssinatura="AlterandoNivelPrioridadeAssinatura"
                  :novosItensTableAssinatura="novosItensTableAssinatura"
                >
                </signatureTemplate>
             </b-tab>
             <b-tab :title="'Autorizações'">
              <template slot="title" >
              <span class="d-md-down-none pl-1 text-third">Log</span>
              </template>
                <HeadDetailsGama :titleHead="'Detalhes do Template'"  style="font-family: 'Segoe UI'" :buttontemplate="true" v-on:voltarPersonalizado="voltar()" :btnBack="true">
                <template #button-edit>
                  <div class="d-flex">
                  </div>
                </template>
                </HeadDetailsGama>
                <logTemplateQma ref="LogQMATemplate" :templateid="templateid"></logTemplateQma>
             </b-tab>
        </b-tabs>
        <newHeader :templateid="templateid" ref="newCabecalho" @AdicionarTableCabecalho="AdicionarTableCabecalho" @salvarNovosItensCabecalho="salvarNovosItensCabecalho"></newHeader>
        <newSignature :templateid="templateid" :tipoTemplate="tipoTemplate" ref="newAssinatura" @AdicionarTableAssinatura="AdicionarTableAssinatura" @salvarNovosItensAssinatura="salvarNovosItensAssinatura"></newSignature>
        <newGuidance :templateid="templateid" @AlteracaoOrientacao="AlteracaoOrientacao" @EditaOrientacao="EditaOrientacao" :tipoTemplate="tipoTemplate" ref="newOrientacao" @AdicionarTableOrientacao="AdicionarTableOrientacao" @salvarNovosItensOrientacao="salvarNovosItensOrientacao"></newGuidance>

        <b-modal ref="confimacao-retornar"
        size="md"
        centered
        title=""
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        >
          <template #modal-title>
            <div class="header-title">Retornar a consulta de Templates</div>
          </template>
        <returnGridTemplate @retonar="confirmacaoVoltar" @cancelaRetorno="cancelarVoltar"></returnGridTemplate>
      </b-modal>
      <deleteQuestion
          ref="modalExcluir"
          :templateid="templateid"
          :subGrupo="false"
          :orientacao="orientacaopropsexclusao"
          :cabecalho="cabecalhopropsexclusao"
          :assinatura="assinaturapropsexclusao"
          @removerDaTableEdicoes="removerDaTableEdicoes"
          @removerOrientacaoDaTableEdicoes="removerOrientacaoDaTableEdicoes"
          @removerAssinaturaDaTableEdicoes="removerAssinaturaDaTableEdicoes"
      >
      </deleteQuestion>
    </div>
  </template>

<script>
import tabsTemplate from './tabsTemplate'
export default tabsTemplate
</script>
  <style scoped>
  .custom-control-input:checked~.custom-control-label::before {
    border-color: #9cd9a3;
    background-color: #9cd9a3
  }
  .icone-alerta {
    display: flex;
    margin: 1rem 0 1rem 0;
    justify-content: center;
    font-size: 55px;
    color: darkgreen;
  }
  .font-clone{
    display: flex;
    justify-content: center;
    color: rgb(128, 128, 128);
    font-weight: bold;
    font-size: 16px;
    font-family: 'Segoe UI';
  }
  .container_cancel_save{
    justify-content: center;
    width: 100%;
    margin-top: 1.5rem;
    column-gap: 10px;
   }

    .header-title{
      color: white;
      font-weight: bold;
      font-size: 16px;
      font-family: 'Segoe UI';
    }
    .add{
      margin-right: 0.6rem;
      cursor: pointer;
      padding: 5px;
    }
    .excDisable{
      margin-right: 1rem;
      cursor: pointer;
      border: transparent;
      border-radius: 6px;
      background-color: rgb(191, 191, 191);
      color: rgb(64, 64, 64);
      padding: 5px;
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
    .exc{
      margin-right: 1rem;
      border: transparent;
      cursor: pointer;
      border-radius: 6px;
      background-color: rgb(255, 205, 205);
      color: rgb(136, 22, 22);
      padding: 5px;
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
    .excPreRequisito{
      margin-right: 0rem;
      cursor: pointer;
      border-radius: 3px;
      width: 2rem;
      border: 1px solid rgb(136, 22, 22);
      color: rgb(136, 22, 22);
      padding: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .font-bold {
      font-weight: bold;
    }
    .font {
      font-family: 'Segoe UI';
      font-size: 12px;
    }

  .margim{
    margin-top: 1rem;
  }
  .col-md-3{
    padding-right: 0;
    padding-left: 0;
   }
  .title-card-sales {
    font-size: 24px;
    background: #008144;
    padding: 20px;
    border-radius: 8px 8px 0px 0px;
    color: white;
    font-weight: bold;
  }
  .buton_salvar{
    display: flex;
    float: right;
    justify-content: end;
    gap: 10px;
  }
  .buttonsave{
    margin-top: 10;
    font-size: 12px;
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 170px;
    height: 30px;
    background-color: #008144;
    color: white;
  }
  .buttonpublish{
    margin-top: 10;
    font-size: 12px;
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 170px;
    height: 30px;
    background-color: #0b5ed7;
    color: white;
  }
  .buttonunpublish{
    margin-top: 10;
    font-size: 12px;
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 170px;
    height: 30px;
    background-color: #bc4807;
    color: white;
  }
  /* ZOP-65: mesma caixa dos outros botoes do header, em cinza pra nao competir
     visualmente com SALVAR/PUBLICAR, que sao as acoes principais da tela. */
  .buttonduplicate{
    margin-top: 10;
    font-size: 12px;
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 170px;
    height: 30px;
    background-color: #6c757d;
    color: white;
  }
  .buttonduplicate:hover{ background-color: #5a6268; }
  .buttonsavedisable{
    margin-top: 10;
    font-size: 12px;
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 170px;
    height: 30px;
    background-color: rgb(191, 191, 191);
    color: rgb(64, 64, 64);
  }
  .button-cancel{
    background-color: #b60000;
    margin-top: 10;
    font-size: 12px;
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 100px;
    height: 30px;
    color: white;
  }
 </style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/tabsTemplate.vue